import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function TagFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.8984 1.97327H12.6984C11.9984 1.97327 11.2984 2.27327 10.7984 2.77327L2.79839 10.7733C1.69839 11.8733 1.69839 13.5733 2.79839 14.6733L9.99839 21.8733C11.0984 22.9733 12.7984 22.9733 13.8984 21.8733L21.8984 13.8733C22.3984 13.3733 22.6984 12.6733 22.6984 11.9733V2.77327C22.6984 2.37327 22.3984 1.97327 21.8984 1.97327ZM17.8984 8.67327C16.7984 8.67327 15.8984 7.77327 15.8984 6.67327C15.8984 5.57327 16.7984 4.67327 17.8984 4.67327C18.9984 4.67327 19.8984 5.57327 19.8984 6.67327C19.8984 7.77327 18.9984 8.67327 17.8984 8.67327Z"
				fill="currentColor"
			/>
		</svg>
	);
}

TagFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default TagFilledIcon;
